var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetStartedDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stars-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.41667 11.4872L6.07038 12.7946C6.29162 13.2371 6.40224 13.4583 6.55003 13.65C6.68116 13.8202 6.83367 13.9727 7.00379 14.1038C7.19551 14.2516 7.41675 14.3622 7.85924 14.5835L9.16667 15.2372L7.85924 15.8909C7.41675 16.1121 7.19551 16.2227 7.00379 16.3705C6.83367 16.5017 6.68116 16.6542 6.55003 16.8243C6.40224 17.016 6.29162 17.2373 6.07038 17.6797L5.41667 18.9872L4.76295 17.6797C4.54171 17.2373 4.43109 17.016 4.28331 16.8243C4.15217 16.6542 3.99966 16.5017 3.82954 16.3705C3.63782 16.2227 3.41658 16.1121 2.9741 15.8909L1.66667 15.2372L2.9741 14.5835C3.41658 14.3622 3.63782 14.2516 3.82954 14.1038C3.99966 13.9727 4.15217 13.8202 4.28331 13.65C4.43109 13.4583 4.54171 13.2371 4.76295 12.7946L5.41667 11.4872Z",
    stroke: "#676A73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.3205L13.4822 4.87419C13.7172 5.48521 13.8347 5.79072 14.0174 6.0477C14.1794 6.27546 14.3784 6.47446 14.6061 6.63641C14.8631 6.81914 15.1686 6.93664 15.7797 7.17165L18.3333 8.15384L15.7797 9.13602C15.1686 9.37103 14.8631 9.48854 14.6061 9.67127C14.3784 9.83322 14.1794 10.0322 14.0174 10.26C13.8347 10.517 13.7172 10.8225 13.4822 11.4335L12.5 13.9872L11.5178 11.4335C11.2828 10.8225 11.1653 10.517 10.9826 10.26C10.8206 10.0322 10.6216 9.83322 10.3939 9.67127C10.1369 9.48854 9.83137 9.37103 9.22035 9.13602L6.66667 8.15384L9.22035 7.17165C9.83137 6.93664 10.1369 6.81914 10.3939 6.63641C10.6216 6.47446 10.8206 6.27546 10.9826 6.0477C11.1653 5.79072 11.2828 5.48521 11.5178 4.87419L12.5 2.3205Z",
    stroke: "#676A73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStartedDefault);
export default __webpack_public_path__ + "static/media/getStartedDefault.f1d922dab283dfe0dd39e89e32299ea1.svg";
export { ForwardRef as ReactComponent };